import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-hierarchical-page-menu',
  templateUrl: './hierarchical-page-menu.component.html',
  styleUrls: ['./hierarchical-page-menu.component.scss'],
  standalone: false
})
export class HierarchicalPageMenuComponent {
  @Input() pageMap: any;
  @Input() activePageCode: string = '';
  @Input() pages: string[] = [];
  @Input() level: number = 0;
  @Output() pageSelected = new EventEmitter<string>();
  
  // activePageCode: string = '';
  handlePageClick(page: any) {
    // emit event or navigate
    console.log('Navigating to page:', page);
    this.activePageCode = page.code;
    this.pageSelected.emit(page);
  }
  
}
